import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox, SelectTag } from '../../../../../../components';
import { Button, Container, Dialog, IconButton, Paper, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, request, toast } from '../../../../../../utils';
import { CustomButtonn } from '../../../../../../components';
import { useLocation } from 'react-router-dom';

const initialPurchaseUomDataObj = {
  data: [],
  loading: false
};

const TABLE_COLUMNS = [
  {
    header: 'UOM Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.unit_name}`}
        </span>
      );
    }
  },
  {
    header: 'UQC Name',
    accessor: (row) => row?.uqc_name?.description
  },
  {
    header: 'status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

export const PurchaseUom = ({ getPurchaseUom, setPurUomDialogue }) => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [uomDataObj, setUomDataObj] = useState(initialPurchaseUomDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const [uqc, setUqc] = useState([]);
  const lastPathSegment = pathname.split('/').pop();

  const getUqc = useCallback(async () => {
    const data = await dropdownFetch('uqc-master');
    setUqc(data);
  }, []);

  useEffect(() => {
    getUqc();
  }, [getUqc]);

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({ unit_name: Yup.string().required('Unit Name is required') })),
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('unit_name', selectedRecord.unit_name);
      setValue('uqc_name', selectedRecord.uqc_name);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/purchase-uom-update' : '/purchase-uom-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        unit_name: formValues.unit_name,
        uqc_name: formValues.uqc_name
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Purachase Uom Details`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
      handleFetchList();
      getPurchaseUom();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Purchase Uom Details`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/purchase-uom-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Purchase Uom', { variant: 'success' });
      setSelectedRecord();
      handleFetchList();
    } else {
      toast('Failed to Cancelled Purchase Uom', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/purchase-uom-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Purchase Uom', { variant: 'success' });
      setSelectedRecord();
      handleFetchList();
    } else {
      toast('Failed to delete Purchase Uom', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleFetchList = async () => {
    setOpenQueryDialog(true);
    setUomDataObj({ loading: true });
    const response = await request('/purchase-uom-list', { method: 'GET' });
    const filteredData = response.data.filter(
      (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
    );
    if (response.success) {
      setUomDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setUomDataObj({ loading: false });
    }
  };
  useEffect(() => {
    handleFetchList();
  }, []);
  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto',
          maxWidth: '100vw',
          minHeight: '100vh'
        }}
      >
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 1,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Purchase unit of Material
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }} spacing={1}>
                <CustomButtonn
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                  id={`${lastPathSegment}Write`}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                    setPurUomDialogue(false);
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Stack spacing={2} sx={{ marginBottom: '1%' }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.4, fontSize: '1.6rem', fontWeight: 700 }}>Unit Name</Typography>
                <TextField
                  name="unit_name"
                  sx={{
                    flex: 0.8,
                    border: currentAction ? '0.5px solid red' : '',
                    backgroundColor: currentAction ? '#B3E5FC' : ''
                  }}
                  inputProps={{ sx: { fontSize: '1.4rem' } }}
                  placeholder="Unit Name"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.4, fontSize: '1.6rem', fontWeight: 700 }}>UQC</Typography>
                <SelectTag
                  name="uqc_name"
                  formControlSX={{
                    flex: 0.8,
                    border: currentAction ? '0.5px solid red' : '',
                    backgroundColor: currentAction ? '#B3E5FC' : ''
                  }}
                  placeholder="UQC Name"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                  menus={uqc.map((data) => ({
                    ...data,
                    name: data.description
                  }))}
                />
              </Stack>
            </Stack>
            <Stack
              padding={0}
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
              borderBottom="1px solid"
              borderColor="grey.300"
            ></Stack>
            <Table
              sx={{ mt: 0.5 }}
              columns={TABLE_COLUMNS}
              data={uomDataObj.data || []}
              loading={uomDataObj.loading}
              onRowClick={(row) => {
                const { uqc_name, ...otherDetails } = row;
                setSelectedRecord({
                  ...otherDetails,
                  uqc_name: uqc_name?._id
                });
                setOpenQueryDialog(false);
              }}
            />
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
